module.exports = __webpack_public_path__ + "img/super-fast-service.501bfa3.svg";